
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-to-video",
      function () {
        return require("private-next-pages/image-to-video/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-to-video"])
      });
    }
  